import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  id: string;
  length: number;
  maxLength: number;
};
// Live "used / max" hint for inputs with a maxLength. Announced politely so screen readers get
// the count without being interrupted on every keystroke.
export const CharacterCounter = ({ className, id, length, maxLength }: Props) => (
  <p
    aria-live="polite"
    className={classnames('shrink-0 pt-5 text-12 text-grey', className)}
    id={id}
  >
    {length}/{maxLength}
  </p>
);
